import React from 'react';
import './SeeMore.scss';

const SeeMore = ({title, vermas, url}) => {
    
    return (
        <div className="see-more">
            <a href={url} target="_blank"><p>{vermas}</p></a>
        </div>                                
    )
};
  
  export default SeeMore;